import { ProfileInfo } from "../../../components/profileInfo/profileInfo";
import { ArrowIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { Link } from "react-router";

export const WorkerItem = ({ data }) => {
    return (
        <Link to={`${data.userId}`} viewTransition>
            <Button
                text={<ProfileInfo photo={data.photo} name={data.name} />}
                icon={<ArrowIcon />}
                type="secondary"
            />
        </Link>
    );
}